import React, { useEffect, useState } from 'react'
import { Badge, ListItem } from '@mui/material'
import moment from 'moment'
import './Message.css'

const ActiveSubjects = (props) => {
    return (
        <ul className="activeSubjects">
            {props.sellerMessages.projectmessages ? (
                props.sellerMessages.projectmessages.map(
                    (projectMessage, index) => (
                        <ListItem
                            button
                            key={index}
                            className={
                                props.selectedProject ===
                                projectMessage.project_id
                                    ? 'active'
                                    : ''
                            }
                            onClick={(e) =>
                                props.onClick(
                                    e,
                                    index,
                                    props.sellerMessages.seller_id,
                                    props.sellerMessages.messageunreadcount -
                                        projectMessage.unreadcount,
                                    projectMessage.project_id
                                )
                            }
                        >
                            <div className="d-flex justify-content-between flex-wrap w-100">
                                <div className="subjectContent d-flex justify-content-start w-100 flex-column align-items-start subjectMsg">
                                    <h4 className="asTitle">
                                        {projectMessage.title}
                                    </h4>
                                    <h6 className="ml-0">
                                        {moment(
                                            projectMessage.date_sent
                                        ).format('DD-MM-YYYY')}
                                    </h6>
                                </div>
                                <div className="asContent d-flex justify-content-between w-100 align-items-center">
                                    <h5 className="asSubject">
                                        {projectMessage.conversationcount +
                                            ' ' +
                                            'Conversations'}
                                    </h5>
                                    <div className="d-flex justify-content-end">
                                        {props.isArchive ? (
                                            <a
                                                onClick={(e) => {
                                                    props.handleUnarchiveButtonClick(
                                                        props.sellerMessages
                                                            .seller_id,
                                                        projectMessage.project_id
                                                    )
                                                    e.stopPropagation()
                                                }}
                                            >
                                                <span className="material-icons">
                                                    unarchive
                                                </span>
                                            </a>
                                        ) : (
                                            <a
                                                onClick={(e) => {
                                                    props.handleArchiveButtonClick(
                                                        props.sellerMessages
                                                            .seller_id,
                                                        projectMessage.project_id
                                                    )
                                                    e.stopPropagation()
                                                }}
                                                style={{ height: '20px' }}
                                            >
                                                <span
                                                    className="material-icons"
                                                    style={{ fontSize: '20px' }}
                                                >
                                                    archive
                                                </span>
                                            </a>
                                        )}

                                        {projectMessage.unreadcount > 0 ? (
                                            <Badge
                                                badgeContent={
                                                    projectMessage.unreadcount
                                                }
                                            ></Badge>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>
                        </ListItem>
                    )
                )
            ) : (
                <div className="noSelection seller">
                    <div className="text-center">
                        <span className="material-icons">person</span>
                        <h4>No Seller Selected</h4>
                        <h6>Select a seller to view conversations</h6>
                    </div>
                </div>
            )}
        </ul>
    )
}

export default ActiveSubjects
